import { baseUrl } from "../config/constants";
import { handleCookies } from "../utils/cookies";

const getToken = () => {
  const { token } = handleCookies.fetchCookies();
  return "Bearer " + token;
};
const getPolicyAddresses = async ({ policy_id }) => {
  try {
    const response = await fetch(`${baseUrl}/policyAddresses`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({ policy_id: policy_id }),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch addresses");
    }
    return data.data;
  } catch (error) {
    console.error("Error fetching addresses:", error);
    throw error;
  }
}

export {
  getPolicyAddresses
};